export default "__VITE_ASSET__e9611f54__"